import React from "react";
import { ArrowRight, BadgeCheck, Award, Globe2 } from "lucide-react";
import { doctor } from "../mock";

const Hero = () => {
  return (
    <section id="top" className="relative bg-navy text-white overflow-hidden">
      {/* background image + navy overlay */}
      <div className="absolute inset-0">
        <img src={doctor.heroBg} alt="" aria-hidden="true" className="w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(36,54,92,0.94) 0%, rgba(36,54,92,0.82) 45%, rgba(36,54,92,0.48) 100%)" }} />
      </div>
      <div className="absolute -top-32 -right-32 w-[30rem] h-[30rem] rounded-full" style={{ background: "radial-gradient(circle, rgba(191,157,87,0.16), transparent 70%)" }} />

      <div className="max-w-6xl mx-auto px-4 pt-16 pb-0 lg:pt-24 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-8 items-center">
          {/* text */}
          <div className="lg:col-span-7 reveal in-view">
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.3em] uppercase text-gold mb-5">
              <BadgeCheck className="w-4 h-4" /> Orthopedic Surgeon
            </span>
            <h1 className="font-head text-4xl sm:text-6xl lg:text-7xl font-bold leading-[0.98] tracking-wide">
              ADAM A.<br />ALBABA, <span className="text-gold">MD</span>
            </h1>
            <p className="text-white/75 text-lg mt-6 max-w-xl leading-relaxed">{doctor.tagline}</p>
            <div className="flex flex-wrap gap-3 mt-6">
              {doctor.focus.map((f) => (
                <span key={f} className="text-[11px] font-semibold tracking-widest uppercase border border-gold/40 bg-gold/5 rounded-full px-4 py-2 text-gold">{f}</span>
              ))}
            </div>
            <div className="flex flex-wrap gap-4 mt-9">
              <a href="#contact" className="group inline-flex items-center gap-2 bg-gold hover:bg-gold-dark text-navy text-xs font-bold tracking-[0.2em] uppercase px-7 py-4 transition-colors">
                Book Consultation <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </a>
              <a href="#timeline" className="inline-flex items-center border border-white/30 hover:border-gold hover:text-gold text-white text-xs font-bold tracking-[0.2em] uppercase px-7 py-4 transition-colors">
                View Training
              </a>
            </div>
          </div>

          {/* portrait card */}
          <div className="lg:col-span-5 flex justify-center lg:justify-end reveal in-view">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-gold" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-gold" />
              <div className="relative w-64 sm:w-80 aspect-[4/5] overflow-hidden rounded-t-[3rem] rounded-b-2xl shadow-2xl bg-navy-2">
                <img src={doctor.photo} alt={doctor.name} className="w-full h-full object-cover object-top" />
                <div className="absolute inset-x-0 bottom-0 h-24" style={{ background: "linear-gradient(to top, rgba(36,54,92,0.85), transparent)" }} />
                <div className="absolute bottom-4 left-0 right-0 text-center">
                  <p className="font-head text-lg font-bold tracking-wide text-white">Adam A. AlBaba, MD</p>
                  <p className="text-[11px] tracking-widest uppercase text-gold">Trauma • Foot &amp; Ankle • Sports Medicine</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* stat strip */}
        <div className="mt-14 grid grid-cols-3 border-t border-white/10">
          {[{ i: Award, t: "Fellowship Trained", s: "3 Subspecialties" }, { i: Globe2, t: "International Training", s: "2 Countries" }, { i: BadgeCheck, t: "AAOS • AOFAS", s: "Member & Reviewer" }].map((x, idx) => {
            const Icon = x.i;
            return (
              <div key={idx} className={`flex items-center gap-3 py-5 px-2 sm:px-6 ${idx > 0 ? "border-l border-white/10" : ""}`}>
                <Icon className="w-6 h-6 text-gold shrink-0" />
                <div>
                  <p className="font-head text-sm sm:text-base uppercase tracking-wide text-white leading-tight">{x.t}</p>
                  <p className="text-[11px] text-white/50">{x.s}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Hero;
